var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgUsa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 6.6C43.3 3.7 37.9 2 32 2v4.6h16z",
    fill: "#ed4c5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 11.2h21.6C51.9 9.5 50 7.9 48 6.6H32v4.6z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 15.8h25.3c-1.1-1.7-2.3-3.2-3.6-4.6H32v4.6z",
    fill: "#ed4c5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 20.4h27.7c-.7-1.6-1.5-3.2-2.4-4.6H32v4.6",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 25h29.2c-.4-1.6-.9-3.1-1.5-4.6H32V25z",
    fill: "#ed4c5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 29.7h29.9c-.1-1.6-.4-3.1-.7-4.6H32v4.6",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9 29.7H32V32H2c0 .8 0 1.5.1 2.3h59.8c.1-.8.1-1.5.1-2.3c0-.8 0-1.6-.1-2.3",
    fill: "#ed4c5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8 38.9h58.4c.4-1.5.6-3 .7-4.6H2.1c.1 1.5.4 3.1.7 4.6",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3 43.5h55.4c.6-1.5 1.1-3 1.5-4.6H2.8c.4 1.6.9 3.1 1.5 4.6",
    fill: "#ed4c5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7 48.1h50.6c.9-1.5 1.7-3 2.4-4.6H4.3c.7 1.6 1.5 3.1 2.4 4.6",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3 52.7h43.4c1.3-1.4 2.6-3 3.6-4.6H6.7c1 1.7 2.3 3.2 3.6 4.6",
    fill: "#ed4c5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9 57.3h32.2c2.1-1.3 3.9-2.9 5.6-4.6H10.3c1.7 1.8 3.6 3.3 5.6 4.6",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 62c5.9 0 11.4-1.7 16.1-4.7H15.9c4.7 3 10.2 4.7 16.1 4.7",
    fill: "#ed4c5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 6.6c-2.1 1.3-4 2.9-5.7 4.6c-1.4 1.4-2.6 3-3.6 4.6c-.9 1.5-1.8 3-2.4 4.6c-.6 1.5-1.1 3-1.5 4.6c-.4 1.5-.6 3-.7 4.6c-.1.8-.1 1.6-.1 2.4h30V2c-5.9 0-11.3 1.7-16 4.6",
    fill: "#428bc1"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 3l.5 1.5H27l-1.2 1l.4 1.5l-1.2-.9l-1.2.9l.4-1.5l-1.2-1h1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 9l.5 1.5H31l-1.2 1l.4 1.5l-1.2-.9l-1.2.9l.4-1.5l-1.2-1h1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 9l.5 1.5H23l-1.2 1l.4 1.5l-1.2-.9l-1.2.9l.4-1.5l-1.2-1h1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 15l.5 1.5H27l-1.2 1l.4 1.5l-1.2-.9l-1.2.9l.4-1.5l-1.2-1h1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 15l.5 1.5H19l-1.2 1l.4 1.5l-1.2-.9l-1.2.9l.4-1.5l-1.2-1h1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15l.5 1.5H11l-1.2 1l.4 1.5l-1.2-.9l-1.2.9l.4-1.5l-1.2-1h1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 21l.5 1.5H31l-1.2 1l.4 1.5l-1.2-.9l-1.2.9l.4-1.5l-1.2-1h1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 21l.5 1.5H23l-1.2 1l.4 1.5l-1.2-.9l-1.2.9l.4-1.5l-1.2-1h1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 21l.5 1.5H15l-1.2 1l.4 1.5l-1.2-.9l-1.2.9l.4-1.5l-1.2-1h1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 27l.5 1.5H27l-1.2 1l.4 1.5l-1.2-.9l-1.2.9l.4-1.5l-1.2-1h1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 27l.5 1.5H19l-1.2 1l.4 1.5l-1.2-.9l-1.2.9l.4-1.5l-1.2-1h1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 27l.5 1.5H11l-1.2 1l.4 1.5l-1.2-.9l-1.2.9l.4-1.5l-1.2-1h1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8 13l1.2-.9l1.2.9l-.5-1.5l1.2-1h-1.5L13 9l-.5 1.5h-1.4l1.2.9l-.5 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.8 25l1.2-.9l1.2.9l-.5-1.5l1.2-1H5.5L5 21l-.5 1.5h-1c0 .1-.1.2-.1.3l.8.6l-.4 1.6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa);
export default __webpack_public_path__ + "static/media/usa.b42fb655e92d8e7982f05ca3d44c0184.svg";
export { ForwardRef as ReactComponent };